import { AppConfiguration } from "./configuration.class";

// Description: Store pdftron constants in config
const pdftron_licenseKey = "PreVeil, Inc.:OEM:PreVeil::B+:AMS(20270420):2F5732731FC794D0133352184F516F2F2292EC2BCD1469C2C7ED60B2329431F5C7";
const pdftron_path = "/webviewer/lib";
export const PDFNETJS_WEBVIEWER_OPTIONS =
    AppConfiguration.buildForWeb() ?
        {
            licenseKey: pdftron_licenseKey,
            path: pdftron_path,
            fullAPI: true,
            disableObjectURLBlobs: true,
            backendType: "asm"
        } : {
            licenseKey: pdftron_licenseKey,
            path: pdftron_path,
            fullAPI: true
        };

